document.addEventListener('DOMContentLoaded', function () {
let processedImageDataURL = null;
let backprocessedImageDataURL = null;

const inverseCheckbox = document.getElementById('inverseCheckbox');
const backinverseCheckbox = document.getElementById('backinverseCheckbox');

function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  return canvas.toDataURL("image/png");
}

/* load image src onto canvas, then run processImage */
function handleImageUpload(event, side) {
  var file = event;
  if (file) {
    var img = new Image();
    img.onload = function() {
      var canvasId = (side === 'front') ? 'imageCanvas' : 'imageCanvasback';
      var canvas = document.getElementById(canvasId);
      var ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      canvas.style.display = 'block';
      processImage(side);
    };
    img.src = event;
  }
}

/* convert image to canvas, normalise black/transparent, call applyTextureToBlackPixels */
function processImage(side) {
  var isFront = (side === 'front');
  var canvas = document.getElementById(isFront ? 'imageCanvas' : 'imageCanvasback');
  var ctx = canvas.getContext('2d');
  var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  var data = imgData.data;
  var tolerance = 40;
  var containsColors = false;

  for (var i = 0; i < data.length; i += 4) {
    var r = data[i], g = data[i + 1], b = data[i + 2];
    if (r < tolerance && g < tolerance && b < tolerance) {
      data[i] = 0; data[i + 1] = 0; data[i + 2] = 0;
    } else if (r > 255 - tolerance && g > 255 - tolerance && b > 255 - tolerance) {
      data[i + 3] = 0;
    } else {
      containsColors = true;
    }
  }

  if (containsColors) {
    for (var j = 0; j < data.length; j += 4) {
      if (data[j + 3] > 0) {
        data[j] = 0; data[j + 1] = 0; data[j + 2] = 0;
      }
    }
  }

  ctx.putImageData(imgData, 0, 0);
  var dataURL = canvas.toDataURL('image/png');

  if (isFront) {
    processedImageDataURL = dataURL;
    $('#cropped_image').attr('src', dataURL);
    $('.front_crop').attr('src', dataURL);
    $('#uploaded-image').attr('src', dataURL);
  } else {
    backprocessedImageDataURL = dataURL;
    $('#cropped_image').attr('src', dataURL);
    $('.back_crop').attr('src', dataURL);
    $('#buploaded-image').attr('src', dataURL);
  }
  applyTextureToBlackPixels(dataURL, side);
}

/* apply colour texture to black pixels, then upload result */
function applyTextureToBlackPixels(imageDataURL, side) {
  var isFront = (side === 'front');
  var imageCanvas = document.getElementById(isFront ? 'imageCanvas' : 'imageCanvasback');
  var ctx = imageCanvas.getContext('2d');
  var selected_colonam = $('.inner_variant .color_items.active').attr('data-color');
  var textureUrl = getBase64Image(document.getElementById("colo64_" + selected_colonam));
  var img = new Image();

  img.onload = function() {
    ctx.clearRect(0, 0, imageCanvas.width, imageCanvas.height);
    ctx.drawImage(img, 0, 0, imageCanvas.width, imageCanvas.height);

    var textureImg = new Image();
    textureImg.onload = function() {
      var tempCanvas = document.createElement('canvas');
      tempCanvas.width = imageCanvas.width;
      tempCanvas.height = imageCanvas.height;
      var tempCtx = tempCanvas.getContext('2d');
      tempCtx.drawImage(img, 0, 0);
      tempCtx.globalCompositeOperation = 'source-in';
      tempCtx.drawImage(textureImg, 0, 0, imageCanvas.width, imageCanvas.height);
      ctx.putImageData(tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height), 0, 0);

      setTimeout(function() {
        var convertedimage = imageCanvas.toDataURL('image/png');
        var uploadedId = isFront ? '#uploaded-image' : '#buploaded-image';
        var imageUrlClass = isFront ? '.front_image_url' : '.back_image_url';
        var galleryNameClass = isFront ? '.gallery_name_front' : '.gallery_name_back';
        $(uploadedId).attr('src', convertedimage);
        var split = $(uploadedId).attr('src').split(',')[1];

        $.ajax({
          url: 'http://aussiepal.leapoffaithtech.com/upload.php',
          type: 'POST',
          data: { image: split, contentType: 'image/png' },
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          success: function(response) {
            $(imageUrlClass).html('http://aussiepal.leapoffaithtech.com/' + response);
            $(galleryNameClass).html('');
            $('.popup_alert').removeClass('active');
            $('.content_1').html('');
            $('.popup_alert .heading').css('display', 'block');
            $('.close_ok').css('display', 'block');
          },
          error: function(xhr, status, error) { console.error(error); }
        });
      }, 1000);
    };
    textureImg.src = textureUrl;
  };
  img.src = imageDataURL;
}

/* invert black ↔ transparent, then re-apply texture */
function invertBlackAndTransparent(side) {
  var isFront = (side === 'front');
  var imageCanvas = document.getElementById(isFront ? 'imageCanvas' : 'imageCanvasback');
  var ctx = imageCanvas.getContext('2d');
  var img = new Image();

  img.onload = function() {
    ctx.clearRect(0, 0, imageCanvas.width, imageCanvas.height);
    ctx.drawImage(img, 0, 0, imageCanvas.width, imageCanvas.height);
    var imageData = ctx.getImageData(0, 0, imageCanvas.width, imageCanvas.height);
    var data = imageData.data;

    for (var i = 0; i < data.length; i += 4) {
      var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
      if (r === 0 && g === 0 && b === 0 && a > 0) {
        data[i + 3] = 0; // black → transparent
      } else if (a === 0) {
        data[i] = 0; data[i + 1] = 0; data[i + 2] = 0; data[i + 3] = 255; // transparent → black
      }
    }

    ctx.putImageData(imageData, 0, 0);
    applyTextureToBlackPixels(imageCanvas.toDataURL('image/png'), side);
  };

  img.src = isFront ? processedImageDataURL : backprocessedImageDataURL;
}

/* inverse front image click */
$(document).on('click', '.s1', function() { $('#inverseCheckbox').trigger('click'); });
inverseCheckbox.addEventListener('change', function() {
  $('.popup_alert').addClass('active');
  $('.content_1').html('Please wait the image is inverting');
  $('.popup_alert .heading').css('display', 'none');
  $('.close_ok').css('display', 'none');
  if (inverseCheckbox.checked) {
    invertBlackAndTransparent('front');
    $('.front_image_invert').html('Yes');
  } else {
    applyTextureToBlackPixels(processedImageDataURL, 'front');
    $('.front_image_invert').html('No');
  }
});

/* inverse back image click */
$(document).on('click', '.s2', function() { $('#backinverseCheckbox').trigger('click'); });
backinverseCheckbox.addEventListener('change', function() {
  $('.popup_alert').addClass('active');
  $('.content_1').html('Please wait the image is inverting');
  $('.popup_alert .heading').css('display', 'none');
  $('.close_ok').css('display', 'none');
  if (backinverseCheckbox.checked) {
    invertBlackAndTransparent('back');
    $('.back_image_invert').html('Yes');
  } else {
    applyTextureToBlackPixels(backprocessedImageDataURL, 'back');
    $('.back_image_invert').html('No');
  }
});

/* accept button */
$(document).on('click', '.accept_btn', function() {
  $("#inverseCheckbox").prop("checked", false);
  $("#backinverseCheckbox").prop("checked", false);

  /* front image upload */
  if ($(".front_tab.tab_items.active")[0]) {
    var cropped_imagewidth = document.getElementById("cropped_image");
    if (cropped_imagewidth.height >= 300 && cropped_imagewidth.width >= 300) {
      $('.resizable').addClass('active');
      $(this).html('Uploading image.....').attr('disabled', 'disabled');
      $('.review_design_uploadimg .cancle_btn').attr('disabled', 'disabled');
      $('#cropbutton').attr('disabled', 'disabled');
      $('.invert_btn').attr('disabled', 'disabled');
      var cropped_image = $('#cropped_image').attr('src');
      handleImageUpload(cropped_image, 'front');
      document.getElementById('inverseCheckbox').disabled = false;

      var checkimage = setInterval(function() {
        var frontimgurrl = $('#uploaded-image').attr('src');
        if (frontimgurrl != undefined) {
          var frontimgurrls = frontimgurrl.split(',')[1];
          $.ajax({
            url: 'http://aussiepal.leapoffaithtech.com/upload.php',
            type: 'POST',
            data: { image: frontimgurrls, contentType: 'image/png' },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            success: function(response) {
              $('.review_design_uploadimg .accept_btn').html(' <i class="fa fa-check"></i> <span>Accept</span>').removeAttr('disabled');
              $('.review_design_uploadimg .cancle_btn').removeAttr('disabled');
              $('#cropbutton').removeAttr('disabled');
              $('.invert_btn').removeAttr('disabled');
              $('.front_image_url').html('http://aussiepal.leapoffaithtech.com/' + response);
              $('.front_image').attr('data-src', cropped_image);
              $('.front_image img.uploadingimg').attr('src', cropped_image);
              $('.front_image .conva_imgs').css('display', 'block');
              $('.back_tab').removeAttr('disabled');
              $('.cancle_btn').addClass('hide');
              $('.review_design_uploadimg').removeClass('active');
              $('#preview_img').removeAttr('src');
              $('.input-options').removeClass('hide');
              $('.front_tab, .back_tab').addClass('hide');
              $('.edit_front_tab, .edit_back_tab').removeClass('hide');
              $('.upload_nav_design .clear_btn').removeClass('hide').removeAttr('disabled');
              $('.upload_nav_design .preview_btn').removeClass('hide').removeAttr('disabled');
              $('.upload_nav_design .addtocart_box').addClass('hide');
              $('#inverseCheckbox').css('display', 'inline');
              $('#backinverseCheckbox').css('display', 'none');
              $('.inverse_color').css('display', 'block');
              $('.s1').css('display', 'inline');
              $('.s2').css('display', 'none');
              if ($('.front_image .cstm_textup').html() != '') {
                $('.front_image').addClass('both_textactive');
              }
            },
            error: function(xhr, status, error) { console.error(error); }
          });
          clearInterval(checkimage);
        }
      }, 1000);
    } else {
      $('.popup_alert').addClass('active');
      $('.content_1').html('The image is too small. Please Crop an image that is a minimum of 300px in width and height, excluding whitespace.');
    }
  }

  /* back image upload */
  if ($(".back_tab.tab_items.active")[0]) {
    var bcropped_imagewidth = document.getElementById("cropped_image");
    if (bcropped_imagewidth.height >= 300 && bcropped_imagewidth.width >= 300) {
      $('.resizable').addClass('active');
      $(this).html('Uploading image.....').attr('disabled', 'disabled');
      $('.review_design_uploadimg .cancle_btn').attr('disabled', 'disabled');
      $('#cropbutton').attr('disabled', 'disabled');
      $('.invert_btn').attr('disabled', 'disabled');
      var bropped_image = $('#cropped_image').attr('src');
      handleImageUpload(bropped_image, 'back');

      var checkimageback = setInterval(function() {
        var backimgurrl = $('#buploaded-image').attr('src');
        if (backimgurrl != undefined) {
          var backCrops = backimgurrl.split(',')[1];
          $.ajax({
            url: 'http://aussiepal.leapoffaithtech.com/upload.php',
            type: 'POST',
            data: { image: backCrops, contentType: 'image/png' },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            success: function(response) {
              $('.review_design_uploadimg .accept_btn').html(' <i class="fa fa-check"></i> <span>Accept</span>').removeAttr('disabled');
              $('.review_design_uploadimg .cancle_btn').removeAttr('disabled');
              $('#cropbutton').removeAttr('disabled');
              $('.invert_btn').removeAttr('disabled');
              $('.back_image_url').html('http://aussiepal.leapoffaithtech.com/' + response);
              $('.back_image').attr('data-src', bropped_image);
              $('.back_image img.uploadingimg').attr('src', bropped_image);
              $('.back_tab').removeAttr('disabled');
              $('.cancle_btn').addClass('hide');
              $('.clear_btn').removeClass('hide').removeAttr('disabled');
              $('.preview_btn').removeClass('hide').removeAttr('disabled');
              $('.review_design_uploadimg').removeClass('active');
              $('.back_image .conva_imgs').css('display', 'block');
              $('#preview_img').removeAttr('src');
              $('.input-options').removeClass('hide');
              $('.front_tab, .back_tab').addClass('hide');
              $('.edit_front_tab, .edit_back_tab').removeClass('hide');
              $('.upload_nav_design .clear_btn').removeClass('hide').removeAttr('disabled');
              $('.upload_nav_design .preview_btn').removeClass('hide').removeAttr('disabled');
              $('.upload_nav_design .addtocart_box').addClass('hide');
              $('#inverseCheckbox').css('display', 'none');
              $('#backinverseCheckbox').css('display', 'inline').removeAttr('disabled');
              $('.inverse_color').css('display', 'block');
              $('.s2').css('display', 'inline');
              $('.s1').css('display', 'none');
              if ($('.back_image .cstm_textup').html() != '') {
                $('.back_image').addClass('both_textactive');
              }
            },
            error: function(xhr, status, error) { console.error(error); }
          });
          clearInterval(checkimageback);
        }
      }, 1000);
    } else {
      $('.popup_alert').addClass('active');
      $('.content_1').html('The image is too small. Please Crop an image that is a minimum of 300px in width and height, excluding whitespace.');
    }
  }
});

});
